import { GenericStatusIndicator, GenericStatusInfoTitle } from '@caresend/types';
import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../../../../../../cards/BasicCard/BasicCard.vue.js';
import __vue_component__$3 from '../../../../../../../symbols/StatusIndicatorWithLabel/StatusIndicatorWithLabel.vue.js';
import TransitionExpand from '../../../../../../../transitions/TransitionExpand/TransitionExpand.js';
import __vue_component__$1 from '../../../../../../../ui/Icon.vue.js';
import __vue_component__$2 from '../../../../../../../ui/Skeleton.vue.js';
import __vue_component__$4 from '../../../../../../../ui/Tag/Tag.vue.js';
import __vue_component__$5 from '../../../../../../../ui/Tooltip/Tooltip.vue.js';

// Make the skeleton shape consistent with displaying one short status.
const defaultStatus = {
    color: GenericStatusIndicator.GREY,
    title: GenericStatusInfoTitle.DEFAULT,
    count: 0,
};
var script = defineComponent({
    name: 'ItineraryChildStatusesCard',
    components: {
        BasicCard: __vue_component__,
        Icon: __vue_component__$1,
        Skeleton: __vue_component__$2,
        StatusIndicatorWithLabel: __vue_component__$3,
        Tag: __vue_component__$4,
        Tooltip: __vue_component__$5,
        TransitionExpand,
    },
    props: {
        isLoading: Boolean,
        statusInfo: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            required: true,
        },
        to: {
            type: Object,
            default: null,
        },
    },
    setup(props) {
        const classNames = computed(() => {
            const names = [];
            if (props.to) {
                names.push('ItineraryChildStatusesCard__inner--clickable');
            }
            return names;
        });
        const uniqueStatusesInfo = computed(() => {
            if (props.isLoading) {
                return [defaultStatus];
            }
            const statuses = new Set(props.statusInfo.map((status) => status.title));
            return Array.from(statuses).map((status) => ({
                ...defaultStatus,
                ...props.statusInfo.find((s) => s.title === status),
                count: props.statusInfo.filter((s) => s.title === status).length,
            }));
        });
        const getDisplayAsTag = (status) => status.title === GenericStatusInfoTitle.ACTION_NEEDED;
        const stripTitle = (status) => ({
            ...status,
            title: status.title === GenericStatusInfoTitle.ACTION_NEEDED ? '' : status.title,
        });
        const titleIcon = computed(() => {
            if (props.title === 'Mail-in') {
                return 'flask';
            }
            if (props.title === 'Supplies') {
                return 'user-md';
            }
            return 'box';
        });
        return {
            classNames,
            getDisplayAsTag,
            stripTitle,
            uniqueStatusesInfo,
            titleIcon,
        };
    },
});

export { script as default };
